var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#F2C94C",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8775 6.5C15.275 6.5 15.6575 6.6575 15.9425 6.9425L19.5575 10.565C19.8425 10.8425 20 11.225 20 11.6225V20C20 20.825 19.325 21.5 18.5 21.5H9.4925C8.6675 21.5 8 20.825 8 20V8C8 7.175 8.675 6.5 9.5 6.5H14.8775ZM11.75 18.5H16.25C16.6625 18.5 17 18.1625 17 17.75C17 17.3375 16.6625 17 16.25 17H11.75C11.3375 17 11 17.3375 11 17.75C11 18.1625 11.3375 18.5 11.75 18.5ZM16.25 15.5H11.75C11.3375 15.5 11 15.1625 11 14.75C11 14.3375 11.3375 14 11.75 14H16.25C16.6625 14 17 14.3375 17 14.75C17 15.1625 16.6625 15.5 16.25 15.5ZM14.75 7.625V11C14.75 11.4125 15.0875 11.75 15.5 11.75H18.875L14.75 7.625Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default-icon.c36022008d01c8fd4e58d184045b8c4a.svg";
export { ForwardRef as ReactComponent };